module.exports = __webpack_public_path__ + "img/icon_dashboard_todayworkingtime02.3c86df1.svg";